import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
//import { mainStyles, theme } from '../styles/Main'
import {
    Typography, useMediaQuery, useTheme,
} from '@mui/material'
import { UseImage, CustomAlertHelpDialog } from './'
import help_INE_back from '../assets/help_INE_back.gif'
import help_back_desktop from '../assets/help_back_desktop.gif'
import { useTranslation } from 'react-i18next'

export const HelpDialogBack = (props) => {
    const theme = useTheme()
    const location = useLocation()
    const matches = useMediaQuery('(max-width:812px)')
    const classes = {} //mainStyles.customHelpDialogStyles()
    const { t } = useTranslation();

    return (
        <CustomAlertHelpDialog closeAction={props.closeAction}
            open={props.open}
            body={
                <div>
                    <div className={classes.textContent}>
                        <Typography
                            variant="h6"
                            gutterBottom> <b>{t("help_identity_back")}</b>
                        </Typography>
                        <Typography
                            variant="subtitle1"
                            gutterBottom>
                            {t("help_identity_back_description")}
                        </Typography>
                    </div>
                    {matches ?
                        <div className={classes.carouselSection1}>
                            <UseImage type='Image' src={help_INE_back} className={classes.imgHelp} />
                        </div>
                        :
                        <div className={classes.carouselSection1}>
                            <UseImage type='Image' src={help_back_desktop} className={classes.imgHelp} />
                        </div>
                    }

                </div>
            }
            Buttons={<></>
                // <Buttons
                //     background_color={theme.palette.primary.main}
                //     text_color='#FFFFFF'
                //     border_color={theme.palette.primary.main}
                //     text='Continuar'
                //     type='button'
                //     size={100}
                //     className={classes.cargarDocsBtn}
                //     click={props.continueCapture}
                // />
            }
        />
    )
}